import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '../../shared/Constants';

@Injectable()
export class SocialNetworkService {

  constructor(private http: HttpClient) {}

  getSocialNetworkList() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );

    return this.http.get(
      Constants.URL_BACKEND + `/piece-social-network`,
      {
        headers: headers,
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/system/services/social-network.service.ts